import React from 'react';

const OtherFactore = ({ daysBetween, factorFranquicia }) => {
  return (
    <div>
      {daysBetween !== null && (
        <p className="text">
          <strong>{daysBetween} Dias</strong>
        </p>
      )}
      {factorFranquicia !== null && (
        <p className="text">
          <strong>Exposure Factor: {factorFranquicia}</strong>
        </p>
      )}
    </div>
  );
};

export default OtherFactore;
